// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1mE4o","bigColWidth":"Table_bigColWidth__3YLor","biggerColWidth":"Table_biggerColWidth__1IGl2","row":"Table_row__W7_7w","col":"Table_col__4qC9h"};